import { render, staticRenderFns } from "./mark-up.vue?vue&type=template&id=428b77c2&"
import script from "./mark-up.vue?vue&type=script&lang=js&"
export * from "./mark-up.vue?vue&type=script&lang=js&"
import style0 from "./mark-up.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports